module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/3/3-66e4b56a65b64ab35c024067d85ea700.jpg";